import { useEffect } from 'react'

import { useAssociateDevice } from '../hooks/useAssociateDevice'
import { useForm } from 'react-hook-form'
import { HiOutlineCheckCircle } from 'react-icons/hi'

import { Box, ModalBody, ModalFooter } from '@chakra-ui/react'

import { Button, FormInputSelectControl } from '@/components/ui'

import { EditDeviceFieldsI } from '../types/types'
import { AssociatedDevice } from './AssociatedDevice'

interface AssociateDevicesIProps {
  deviceData: EditDeviceFieldsI
  onClose: () => void
}

export interface AssociatedDevicesI {
  associateDevice: {
    label: string
    value: string
  }
}

export const AssociateDevices = ({
  deviceData,
  onClose,
}: AssociateDevicesIProps) => {
  const deviceType = deviceData?.type
  const { control, watch, reset } = useForm<AssociatedDevicesI>({
    mode: 'onChange',
  })
  const {
    associatedDeviceOptions,
    selectedDevices,
    addSelectedDeviceOption,
    handleAssociation,
    removeSelectedDeviceOption,
    isDirty,
    isLoading,
  } = useAssociateDevice({
    deviceData,
  })
  const watchAssociateDevice = watch('associateDevice')

  useEffect(() => {
    if (watchAssociateDevice) {
      addSelectedDeviceOption(watchAssociateDevice)
      reset({ associateDevice: null })
    }
  }, [watchAssociateDevice])

  return (
    <>
      <ModalBody p='0'>
        <Box mb='3'>
          <Box fontSize='16px'>Associated Devices</Box>
          <Box fontSize='12px' fontWeight={400} mb='20px'>
            Associate devices with this {deviceType?.toLowerCase()} to include
            clips in related incidents.
          </Box>

          <FormInputSelectControl
            control={control}
            controlShouldRenderValue={false}
            defaultValue={null}
            errorMessage='Select a device'
            id='associateDevice'
            options={associatedDeviceOptions}
            placeholder='Select Devices'
            rules={{ required: true }}
          />

          <Box maxH='250px' mt='3' overflowY='auto'>
            {selectedDevices?.map((d) => (
              <Box key={d.value} maxH='250px' mb='10px'>
                <AssociatedDevice
                  name={d?.label}
                  onClick={() => removeSelectedDeviceOption(d)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter py='4'>
        <Button mr='3' onClick={onClose} variant='secondary'>
          Cancel
        </Button>
        <Button
          isDisabled={!isDirty}
          isLoading={isLoading}
          leftIcon={<HiOutlineCheckCircle size='24px' />}
          loadingText='Saving Changes'
          onClick={handleAssociation}
        >
          Save Changes
        </Button>
      </ModalFooter>
    </>
  )
}
